import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { router } from './router';
import { ThemeProvider } from '@/shared/ui/theme-provider';
import { TooltipProvider } from '@/shared/ui/tooltip';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        {/* Global tooltip context — lets HelpIcon and any icon-button
            tooltip work without every page re-wrapping. Nested
            TooltipProviders are still valid, they just override the
            delayDuration for their subtree. */}
        <TooltipProvider delayDuration={200}>
          <RouterProvider router={router} />
          <Toaster richColors closeButton />
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
